import {
  AGGREGATIONS,
  CERTIFICATE_REQUESTS,
  LOGISTICS_REQUESTS,
  OPEN_ADS,
  PRODUCT_ORDER_QA,
  TRANSIT_ORDERS,
} from "../Routes/Routes";
export const ROLES = {
  FARMING_ASSOCIATION: 1,
  PRODUCT_AGGREGATOR: 2,
  QA_COMPANY: 3,
  LOGISTICS_COMPANY: 4,
  SINGLE_BUYER: 5,
  CORPORATE_BUYER: 6,
  FARMER: 7,
  FINANCE_COMPANY: 8,
  INPUT_SUPPLIER: 9,
  ADMIN: 10,
  SUPER_ADMIN: 11,
};

export const disabledRoutes = {
  1: [AGGREGATIONS],
  // 1: [AGGREGATIONS, FARMER_SUBSCRIPTION],
  2: [AGGREGATIONS],
  3: [OPEN_ADS, CERTIFICATE_REQUESTS, PRODUCT_ORDER_QA],
  4: [OPEN_ADS, LOGISTICS_REQUESTS, TRANSIT_ORDERS], //TRUCK_INFORMATION
};
